import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { languages } from '../../../../configs/language'
import { getParamsScreeningReport } from '../../../cartAndOrders/store/slice'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import { SelectCustom } from '../../../common/selectCustom'
import EventEmitter, {
  DISABLE_BLOCK_NAVIGATION,
  SHOW_POPUP_ERROR,
} from '../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { COMPONENTS } from '../../../routers/constants'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { Z_INDEX } from '../../../utils/common'
import { formatParamsGetResult } from '../common/helper'
import { selectScreeningIndicatorById } from '../common/store/slice'
import { selectCriteria } from '../selectCriteria/store/slice'
import classes from './index.module.scss'
import {
  changeLanguageCode,
  selectCurrencies,
  selectLanguageCode,
  selectNumberOfCompany,
  selectSortBy,
  selectViews,
  validateExport,
} from './store/slice'

const LANGUAGE_OPTIONS = [
  { label: 'common.ENGLISH', value: languages.en, isI18n: true },
  {
    label: 'common.VIETNAMESE',
    value: languages.vi,
    isI18n: true,
  },
]

export const BuyButton = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const userType = useSelector(selectUserType)
  const locale = useSelector((state) => state.i18n.locale)
  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())
  const views = useSelector(selectViews)
  const numberOfCompanies = useSelector(selectNumberOfCompany)
  const sortBy = useSelector(selectSortBy)
  const criteria = useSelector(selectCriteria())
  const currencies = useSelector(selectCurrencies)
  const languageCode = useSelector(selectLanguageCode)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const [isShow, setIsShow] = useState(false)

  const isDisable =
    AUTHORIZATION_API.allowCheckout[userType.userTypeId] ===
    AUTHORIZATION_TYPE.DISABLE

  useEffect(() => {
    if (!languageCode) {
      dispatch(changeLanguageCode(locale))
    }
  }, [languageCode])

  const handleOpen = () => {
    EventEmitter.dispatch(DISABLE_BLOCK_NAVIGATION, true)
    setIsShow(true)
  }

  const handleClose = () => {
    EventEmitter.dispatch(DISABLE_BLOCK_NAVIGATION, false)
    setIsShow(false)
  }

  const handleChangeLanguage = ({ value }) => {
    dispatch(changeLanguageCode(value))
  }

  const handleCheckOut = () => {
    new Promise((resolve) => {
      dispatch(
        getParamsScreeningReport({
          currencies,
          numberOfCompanies,
          views: views.map((item) => ({ ...item, groupId: undefined })),
          sortBy: sortBy.screeningIndicatorId ? sortBy : undefined,
          rawCriteria: criteria,
          criterias: formatParamsGetResult({
            criteria,
            screeningIndicatorById,
          }).criterias,
        }),
      )
      resolve()
    }).then(() => navigate(`${COMPONENTS.cartAndOrders.route}?screening=true`))
  }

  const handleClick = () => {
    if (isDisable) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [<Translate value="cartAndOrders.message.m20" />],
      })
      return
    }

    let allowExport = false
    dispatch(
      validateExport({
        callback: (isValid) => {
          allowExport = isValid
        },
      }),
    )
    if (allowExport) handleOpen()
  }

  return (
    <>
      <Element
        elementName="button"
        onClick={handleClick}
        className={classes.purchaseBtn}
        style={{
          color: '#FFFFFF',
          backgroundColor: '#3DA967',
          opacity: isDisable ? 0.4 : 1,
        }}
      >
        <Icon className="icon-money" style={{ fontSize: 16 }} />
        <Element elementName="span">
          <Translate value="screening.BUY_NOW" />
        </Element>
      </Element>

      <PopupAction
        isShow={isShow}
        title="common.CONFIRMATION"
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: handleClose,
        }}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: handleCheckOut,
        }}
        handleClose={handleClose}
      >
        <Element className="pb1" style={{ color: '#3A414B' }}>
          <Element>
            <Translate value="screening.CONFIRM_EXECUTE_TRANSACTION" />
          </Element>
          <Element className="dFlex gap3 mt2 alignItemsCenter">
            <Translate value="screening.CHOOSE_LANGUAGE" />
            <SelectCustom
              data={LANGUAGE_OPTIONS}
              isI18n
              activeItem={{ value: languageCode }}
              chooseItem={handleChangeLanguage}
              zIndex={Z_INDEX.MODAL + 1}
            />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
